import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {InformationMessageTrigger} from 'src/app/models/information-messages/information-message-trigger';

@Pipe({
  name: 'notificationTrigger',
  standalone: true
})
export class NotificationTriggerPipe implements PipeTransform {

  constructor(private readonly translateService: TranslateService) {
  }

  transform(trigger: string): string {
    const notificationTriggers = [
      { trigger: InformationMessageTrigger.SCHEDULED_EXPORT_DISPO_MONTHLY, i18n: 'scheduledExportDispoMonthly' },
      { trigger: InformationMessageTrigger.SCHEDULED_EXPORT_GNL_DAILY, i18n: 'scheduledExportGnlDaily' },
      { trigger: InformationMessageTrigger.SCHEDULED_EXPORT_REQUEST, i18n: 'scheduledExportRequest' },
      { trigger: InformationMessageTrigger.STATIONS_STATE_BECAME_AVAILABLE, i18n: 'stationsStateBecameAvailable' },
      { trigger: InformationMessageTrigger.STATIONS_STATE_BECAME_UNAVAILABLE, i18n: 'stationsStateBecameUnavailable' },
      { trigger: InformationMessageTrigger.STATION_OPENED, i18n: 'stationOpened' },
      { trigger: InformationMessageTrigger.STATION_CLOSED, i18n: 'stationClosed' },
      { trigger: InformationMessageTrigger.TICKET_CREATION, i18n: 'ticketCreation' },
      { trigger: InformationMessageTrigger.TICKET_ESCALATION, i18n: 'ticketEscalation' },
      { trigger: InformationMessageTrigger.TICKET_ESTIMATED, i18n: 'ticketEstimated' },
      { trigger: InformationMessageTrigger.TICKET_CLOSED, i18n: 'ticketClosed' },
      { trigger: InformationMessageTrigger.TRANSACTION_REPORT_CREATED, i18n: 'transactionReportCreated' },
      { trigger: InformationMessageTrigger.USER_CREATION, i18n: 'userCreation' },
      { trigger: InformationMessageTrigger.USER_FORGOT_PASSWORD, i18n: 'userForgotPassword' },
      { trigger: InformationMessageTrigger.USER_NEED_REGISTER, i18n: 'userNeedRegister' },
      { trigger: InformationMessageTrigger.USER_RESET_PASSWORD, i18n: 'userResetPassword' },
      { trigger: InformationMessageTrigger.USER_PERMANENT_DELETION, i18n: 'userPermanentDeletion' },
      { trigger: InformationMessageTrigger.STATION_UNLOADING, i18n: 'stationUnloading' },
      { trigger: InformationMessageTrigger.STATION_LOADING, i18n: 'stationLoading' },
      { trigger: InformationMessageTrigger.AUTH_SUPPORT_BLOCKED, i18n: 'authSupportBlocked' },
      { trigger: InformationMessageTrigger.AUTH_SUPPORT_ACTIVATED, i18n: 'authSupportActivated' },
      { trigger: InformationMessageTrigger.EXPORT_REQUEST_DONE, i18n: 'exportRequestDone' },
      { trigger: InformationMessageTrigger.EXPORT_REQUEST_ERROR, i18n: 'exportRequestError' },
      { trigger: InformationMessageTrigger.EXPORT_REQUEST_SUPPORT, i18n: 'exportRequestSupport' },
      { trigger: InformationMessageTrigger.EXTERNAL_API_AVAILABLE, i18n: 'externalApiAvailable' },
      { trigger: InformationMessageTrigger.EXTERNAL_API_UNAVAILABLE, i18n: 'externalApiUnavailable' },
      { trigger: InformationMessageTrigger.STATION_THUNDERSTORM, i18n: 'stationThunderstorm' },
      { trigger: InformationMessageTrigger.EXPORT_REQUEST_DONE_DOWNLOAD_LINK, i18n: 'exportRequestDoneDownloadLink' },
      { trigger: InformationMessageTrigger.ONBOARDING_INVITATION, i18n: 'onboardingInvitation' },
      { trigger: InformationMessageTrigger.TAG_THRESHOLD_EXCEEDED_HIGH, i18n: 'tagThresholdExceededHigh' },
      { trigger: InformationMessageTrigger.TAG_THRESHOLD_EXCEEDED_LOW, i18n: 'tagThresholdExceededLow' },
      { trigger: InformationMessageTrigger.TAG_THRESHOLD_EXCEEDED_GOOD, i18n: 'tagThresholdExceededGood' },
    ];

    const notificationTrigger = notificationTriggers.find(t => InformationMessageTrigger[t.trigger] === trigger);
    return notificationTrigger
      ? this.translateService.instant(`notifications.trigger.${notificationTrigger.i18n}`)
      : trigger;
  }

}
